import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ConfigService } from './../config/config.service';

@Injectable({
  providedIn: 'root'
})
export class HerramientasService {
  headers: HttpHeaders = new HttpHeaders({
    Accept: 'application/json',
    'Content-Type': 'application/json; charset=utf-8'
  });

  constructor(
    private httpClient: HttpClient,
    private config: ConfigService
  ) { }

  async cierreLlavesTbk() {
    const config = await this.config.getConfig();
    const url = `${ config['endpoint'] }/PagoTbk/CierreTbk`;

    try {
      return await this.httpClient.post(url, null, { headers: this.headers }).toPromise();
    } catch (error) {
      return { status: false, code: 804, message: 'Error al ejecutar la petición.' };
    }
  }

  async apagarEquipo() {
    const config = await this.config.getConfig();
    const url = `${ config['endpoint'] }/PagoTbk/ApagarEquipo`;

    try {
      return await this.httpClient.post(url, null, { headers: this.headers }).toPromise();
    } catch (error) {
      return { status: false, code: 804, message: 'Error al ejecutar la petición.' };
    }
  }

  async reiniciarEquipo() {
    const config = await this.config.getConfig();
    const url = `${ config['endpoint'] }/PagoTbk/ReiniciarEquipo`;

    try {
      return await this.httpClient.post(url, null, { headers: this.headers }).toPromise();
    } catch (error) {
      return { status: false, code: 804, message: 'Error al ejecutar la petición.' };
    }
  }

  async compararClave(clave: string, tipo: number) {
    const config = await this.config.getConfig();
    const claveConfig = tipo === 1 ? config['uno'] : config['dos'];

    return clave === claveConfig;
  }
}
